import React from 'react';
import { Alert } from '@jjj/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from 'styled-components';
import { t } from '../../../../../../../i18n';

const ActionSentAlert = props => {
  const { toggleBulkInviteAlertVisibility } = props;
  const { palette } = useTheme();

  return (
    <Alert
      type="custom"
      closable
      styleSettings={{
        backgroundColor: palette.info[0],
        customIcon: (
          <span className="info-icon">
            <FontAwesomeIcon icon="info-circle" color={palette.grayscale[5]} />
          </span>
        ),
        textColor: palette.grayscale[5],
        closeIconColor: palette.grayscale[5],
      }}
      isCloseTextVisible
      onClose={toggleBulkInviteAlertVisibility}
      style={{ marginBottom: '9px' }}
      data-cy="job-booking-pool-pools_bulk_invite_sent-alert"
    >
      {t('dash.jobs.bookings.pools_bulk_invite_sent_message')}
    </Alert>
  );
};

export default ActionSentAlert;
